import {ResolveFn} from '@angular/router';
import {DataStorageService} from "../services/data-storage.service";
import {inject} from "@angular/core";
import {filter, skip, tap} from "rxjs";

export const dataResolver: ResolveFn<boolean> = (route, state) => {
  const dataService = inject(DataStorageService);
  return dataService.loaded.pipe(filter(loaded => loaded));
};
